export default __webpack_public_path__ + "static/media/go_daddy.2fa8dec3.svg";